<template>
  <mapa
    :width="960"
    :height="960"
  />
</template>

<script>
/* eslint-disable */

import Vue from 'vue'

// Components

import Mapa from '@/components/Mapa.vue'

// Libs

import color from 'onecolor'


export default {
  name: 'MRE',
  components: {
    Mapa,
  },
  data () {
    return {
      initColor: '#989898',
      palette: {},
    }
  },
  computed: {
    color () {
      return color(this.initColor)
    },
  },
  watch: {
    tonic () {
      this.$router.push({
        path: `/${this.color}`,
      })
    },
  },
  created () {
    // this.handleTonicChange(60)
  },
  beforeMount () {
    //
  },
  mounted () {
    // console.log('this.$router', this.$router)
    if (this.$router.currentRoute.params.n) {
      this.$parent.switchLang(this.$router.currentRoute.params.n)
      // console.log('-->', this.$router.currentRoute.params.n)
    }
  },
  methods: {
    async init () {
      // this.getNoteNameAndSet(this.initial)
    },
  },
}
</script>

<style lang="scss" scoped>
//@import '@/mixin.scss';
  $mainbg: white;

  .home {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: left;
    background-color: $mainbg;
  }
</style>
